import { render, staticRenderFns } from "./InventarList.vue?vue&type=template&id=8d4675bc&scoped=true"
import script from "./InventarList.vue?vue&type=script&lang=js"
export * from "./InventarList.vue?vue&type=script&lang=js"
import style0 from "./InventarList.vue?vue&type=style&index=0&id=8d4675bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4675bc",
  null
  
)

export default component.exports